import { defineComponent, computed, watch } from '@vue/composition-api';
import __vue_component__ from '../SdsIcon/SdsIcon.vue.js';

var script = defineComponent({
    name: 'SdsSegmentedControl',
    props: {
        background: {
            type: String,
            required: false,
            default: 'elevation',
        },
        size: {
            type: String,
            required: false,
            default: 'md',
        },
        tabs: {
            type: Array,
            required: true,
        },
        selectedTab: {
            type: Object,
            required: true,
        },
        iconOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        fullWidth: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    setup: function (props, _a) {
        var emit = _a.emit;
        var selectedIndex = computed(function () { var _a; return (_a = props.tabs) === null || _a === void 0 ? void 0 : _a.findIndex(function (tab) { var _a; return tab.value === ((_a = props.selectedTab) === null || _a === void 0 ? void 0 : _a.value); }); });
        function defaultPreselect() {
            emit('update:selectedTab', props.tabs[0]);
        }
        watch(selectedIndex, function (index) {
            if (index === -1) {
                defaultPreselect();
            }
        }, { immediate: true });
        var iconSize = computed(function () {
            switch (props.size) {
                case 'md':
                    return 'sm';
                case 'sm':
                    return 'xs';
                default:
                    return 'sm';
            }
        });
        return {
            iconSize: iconSize,
            selectedIndex: selectedIndex,
        };
    },
    components: {
        SdsIcon: __vue_component__,
    },
});

export default script;
